/**
 * Валидация суммы с ограничением до 2 знаков после запятой
 *
 * Важно в финансовых приложениях:
 * - Стандарт валют: большинство валют используют максимум 2 знака после запятой
 * - Предотвращение ошибок округления: проблемы с точностью вычислений с плавающей точкой
 * - Соответствие банковским стандартам: банки работают с 2 знаками после запятой
 * - Предотвращение мошенничества: ограничение точности предотвращает обход системы
 */
export const validateAmount = (amount: string | number): boolean => {
  if (amount === '' || amount === null || amount === undefined) {
    return false;
  }

  const amountStr = String(amount).trim();

  if (amountStr === '') {
    return false;
  }

  if (parseFloat(amountStr) < 0) {
    return false;
  }

  const regex = /^\d+(\.\d{1,2})?$/;

  if (!regex.test(amountStr)) {
    return false;
  }

  const parts = amountStr.split('.');
  if (parts.length === 2 && parts[1].length > 2) {
    return false;
  }

  return true;
};

export const formatAmount = (amount: number): string => {
  return parseFloat(String(amount)).toFixed(2);
};

export const normalizeAmount = (amount: string | number): number => {
  const num = parseFloat(String(amount));
  if (isNaN(num)) {
    return 0;
  }
  return parseFloat(num.toFixed(2));
};

export const convertToSmallestUnit = (amount: number): number => {
  return Math.round(amount * 100);
};

export const convertFromSmallestUnit = (amount: number): number => {
  return amount / 100;
};
